import {
  IconSpriteElectricPlugDisabledThick,
  IconSpriteElectricPlugThick,
  IconSpriteInfoCircleFilled,
} from '@propertyfinder/icons';
import { Fragment, FunctionComponent, h } from 'preact';

import { CountryCodeEnum } from 'common/data/country/code.enum';
import { configGetCountry } from 'common/helper/config/get-country';
import { domClassMerge } from 'common/helper/dom/class-merge';
import { i18nTranslate } from 'common/helper/i18n/translate';
import { PropertyUtilitiesPriceTypeEnum } from 'common/module/property/utilities-price-type.enum';

const isBH = configGetCountry().code === CountryCodeEnum.bh;

export const PropertyCardSectionsPriceInclusiveTemplate: FunctionComponent<{
  className?: string;
  utilityPriceType: string;
}> = ({ className, utilityPriceType }) => {
  if (!isBH || utilityPriceType === PropertyUtilitiesPriceTypeEnum.notSelected) {
    return null;
  }

  return (
    <div className={domClassMerge('price-inclusive', className)}>
      {utilityPriceType === PropertyUtilitiesPriceTypeEnum.exclusive && (
        <Fragment>
          <div className='price-inclusive__text price-inclusive__text--exclusive'>
            <IconSpriteElectricPlugDisabledThick className='price-inclusive__icon' />
            {i18nTranslate('Exclusive')}
          </div>

          <div className='price-inclusive__tooltip'>
            <IconSpriteInfoCircleFilled className='price-inclusive__icon price-inclusive__icon--tooltip' />
            <span className='tooltip2 tooltip2--top'>
              <span className='tooltip2__content'>{i18nTranslate('Price excludes water and electricity')}</span>
            </span>
          </div>
        </Fragment>
      )}
      {utilityPriceType === PropertyUtilitiesPriceTypeEnum.inclusive && (
        <Fragment>
          <div className='price-inclusive__text'>
            <IconSpriteElectricPlugThick className='price-inclusive__icon' />
            {i18nTranslate('Inclusive')}
          </div>

          <div className='price-inclusive__tooltip'>
            <IconSpriteInfoCircleFilled className='price-inclusive__icon price-inclusive__icon--tooltip' />
            <span className='tooltip2 tooltip2--top price-inclusive__tooltip2'>
              <span className='tooltip2__content'>{i18nTranslate('Price includes water and electricity')}</span>
            </span>
          </div>
        </Fragment>
      )}
    </div>
  );
};
